enum AppMonitorAttribute {
  DeviceFontScale = "device.font_scale",
  DeviceTheme = "device.theme",
  IsAccessibilityServiceEnabled = "accessibility.is_accessibility_service_enabled",
  IsBoldTextEnabled = "accessibility.is_bold_text_enabled",
  IsGrayscaleEnabled = "accessibility.is_grayscale_enabled",
  IsHighTextContrastEnabled = "accessibility.is_high_text_contrast_enabled",
  IsInvertColorsEnabled = "accessibility.is_invert_colors_enabled",
  IsReduceMotionEnabled = "accessibility.is_reduce_motion_enabled",
  IsReduceTransparencyEnabled = "accessibility.is_reduce_transparency_enabled",
  IsScreenReaderEnabled = "accessibility.is_screen_reader_enabled",
}

export { AppMonitorAttribute };
